import type { DataGap } from '../types/siteEvidence';
import type { DataSource } from '../types/siteRag';

/**
 * Drop blind-spot rows whose field already appears as a verified provider
 * reference in the appendix (legacy reports with stale sed.gaps snapshots).
 */
export function filterStaleBlindSpotGaps(
  gaps: DataGap[],
  references: DataSource[] | undefined,
): DataGap[] {
  if (!references?.length || gaps.length === 0) return gaps;

  const verifiedFields = new Set(
    references
      .filter(r => {
        if (!r.field || !r.source?.trim()) return false;
        const src = r.source.toLowerCase();
        return !src.includes('unavailable') && !src.includes('failed');
      })
      .map(r => r.field!),
  );

  if (verifiedFields.size === 0) return gaps;
  return gaps.filter(g => !verifiedFields.has(g.field));
}
